<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>
<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Программы</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down"></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="complex.headers" :search="search" :items="programsData"
                :rows-per-page-items="[10, 25, 50, 100]" :loading="programsData.length === 0" item-key="id"
                class="elevation-1" no-results-text="Нет результатов" rows-per-page-text="На странице"
                v-model="complex.selected">
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.programName }}</td>
                  <td>{{ props.item.employeeName }}</td>
                  <td>{{ props.item.shopEmployeeId }}</td>
                  <td>{{ props.item.shopName }}</td>
                  <td>{{ programStatusData.filter(status => status.statusId === props.item.status && status.programId
                    === props.item.programId).length > 0 ? programStatusData.filter(status => status.statusId ===
                      props.item.status && status.programId === props.item.programId)[0].statusName : '--' }}</td>
                  <td>
                    <v-btn flat icon dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn flat icon dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->

              <div slot="widget-content">
                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">Редактирование</span>
                      <span class="headline" v-if="editedIndex === -1">Добавление</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <!-- Содержание программы -->
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Стоматолог</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Стоматолог" :items="employeeListShopSelect"
                              no-data-text="Нет доступных стоматологов" v-model="modalData.shopEmployeeId"
                              :rules="rules.program" return-object @change="changeEmployee($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <!-- Описание методики -->
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Клиника</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Клиника" :items="clinicList" v-model="modalData.shopId" return-object
                              @change="changeClinic($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <!-- ID Программы -->
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Программа</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Программа" :items="programList" no-data-text="Нет доступных программ"
                              v-model="modalData.programId" return-object
                              @change="changeProgram($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <!-- Статус программы -->
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Статус программы</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Статус" :items="programStatusList"
                              no-data-text="Нет доступных статусов" v-model="modalData.status" return-object
                              @change="changeStatus($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены, что хотите удалить программу "{{ modalData.programName }}" у
                        стоматолога
                        "{{ modalData.employeeName }}" из "{{ modalData.shopName }}"?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <div v-for="prog in countRunProgramData" :key="prog">

                      <v-alert :value="true" color="info" icon="info" style="height: 25px;">
                        Период активности программы
                        с {{ prog.startDate.split(' ')[0] }} по {{ prog.endDate.split(' ')[0] }}
                      </v-alert>

                      <v-data-table :headers="complexPollsProg.headers" :items="programData" hide-actions
                        class="elevation-1" item-key="data.docUid" no-results-text="Нет результатов"
                        rows-per-page-text="На странице" v-model="complexPollsProg.selected" select-all>
                        <template slot="items" slot-scope="props">
                          <td v-if="props.item.countProg == prog.countProg">
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                          </td>
                          <td v-if="props.item.countProg == prog.countProg">{{ props.item.data.visitDate.split(' ')[0]
                            }}</td>
                          <td v-if="props.item.countProg == prog.countProg">{{ props.item.data.employeeName }}</td>
                          <td
                            :style="{ backgroundColor: (props.item.data.shopId != modalData.shopId ? 'orange' : 'transparent') }"
                            v-if="props.item.countProg == prog.countProg">{{ props.item.data.shopName }}</td>
                          <td v-if="props.item.countProg == prog.countProg">{{ props.item.data.pollName }}</td>
                        </template>
                      </v-data-table>
                    </div>

                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn v-if="complexPollsProg.selected.length > 0" color="orange darken-1" flat
                        @click.native="actionRemovePolls(modalData);">Удалить выбранные анкеты</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Удалить программу
                        {{ complexPollsProg.selected.length > 0 ? 'и выбранные анкеты' : '' }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import colors from "vuetify/es5/util/colors";

export default {
  components: {},
  data() {
    return {
      programData: [],
      checkProgram: true,
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      readonlyFields: true,
      openColorBox: false,
      employeeListShop: [],
      colors,
      rules: {
        required: [v => !!v || "Обязательное поле"],
        program: [
          v => !!v || "Стоматолог не может быть пустым",
          v => this.checkProgram || "Такая программа у стоматолога есть"
        ]
      },
      search: "",
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false
      },
      complex: {
        selected: [],
        headers: [
          {
            text: "ID",
            value: "id"
          },
          {
            text: "Программа",
            value: "programName"
          },
          {
            text: "Стоматолог",
            value: "employeeName"
          },
          {
            text: "ID стоматолога",
            value: "shopEmployeeId"
          },
          {
            text: "Клиника",
            value: "shopName"
          },
          {
            text: "Статус",
            value: "status"
          },
          {
            text: "Действия",
            value: ""
          }
        ]
      },
      complexPollsProg: {
        selected: [],
        headers: [
          {
            text: "Дата визита",
            value: "visitDate",
            sortable: false
          },
          {
            text: "Стоматолог",
            value: "employeeName",
            sortable: false
          },
          {
            text: "Клиника",
            value: "shopName",
            sortable: false
          },
          {
            text: "Анкета",
            value: "pollName",
            sortable: false
          }
        ]
      }
    };
  },

  mounted: function () {
    if (!this.programsData.length) this.refresh();

    if (!this.$store.getters['pollTemplates/pollTemplatesData'].length) {
      this.$store.dispatch('pollTemplates/getPollTemplatesData');
    }

    if (!this.$store.getters['clinics/items'].length) {
      this.$store.dispatch('clinics/loadItems');
    }

    if (!this.$store.getters['employees/items'].length) {
      this.$store.dispatch('employees/loadItems');
    }

    if (!this.$store.getters['programStatus/programStatusData'].length) {
      this.$store.dispatch('programStatus/getProgramStatusData');
    }

    if (!this.$store.getters['programList/programListData'].length) {
      this.$store.dispatch('programList/getProgramListData');
    }
  },

  computed: {
    /**
     * Данные по программам
     * @returns {default.computed.programsData|(function())|Array|getters.programsData}
     */
    programsData() {
      return this.$store.getters["programs/programsData"];
    },

    /**
     * Статусы программ
     */
    programStatusData() {
      return this.$store.getters["programStatus/programStatusData"];
    },

    programStatusList() {
      return this.$store.getters["programStatus/programStatusData"]
        .filter(item => this.modalData.programId === item.programId)
        .map(item => {
          return { text: item.statusName, value: item.statusId };
        });
    },

    /**
     * Список стоматологов для select отобранных по клинике
     */
    employeeListShopSelect() {
      return this.$store.getters["employees/items"]
        .filter(item => item.shopId === this.modalData.shopId)
        .map(employee => {
          return {
            text:
              (employee.lastName || '') +
              " " +
              (employee.firstName || '') +
              " " +
              (employee.middleName || ''),
            value: employee.id
          };
        });
    },

    /**
     * Список клиник
     */
    clinicList() {
      return this.$store.getters["clinics/items"].map(item => {
        return {
          text: item.name + ", " + item.address,
          value: item.id
        };
      });
    },

    /**
     * Список стоматологов для select
     * @returns {*}
     */
    employeeList() {
      return this.$store.getters["employees/items"].map(item => {
        return {
          text: item.lastName + " " + item.firstName + " " + item.middleName,
          value: item.id
        };
      });
    },

    /**
     * Список программ для Select'а
     */
    programList() {
      return this.$store.getters["programList/programListData"].map(pt => {
        return {
          text: pt.name,
          value: pt.id
        };
      });
    },

    /**
     * Список анкет по программе
     */
    countRunProgramData() {
      this.programData = [];
      let countProgs = [];
      let countProg = 0;

      this.$store.getters["pollsRunProgram/pollsRunProgramData"].forEach(
        element => {
          if (countProg == 0) {
            countProg = 1;
            countProgs.push({ countProg: countProg, startDate: element.visitDate, endDate: element.visitDate });
            this.programData.push({ countProg: countProg, data: element });
          } else if (countProg > 0) {
            if (element.requiredState != 0) {
              this.programData.push({ countProg: countProg, data: element });
              countProgs[countProg - 1]['endDate'] = element.visitDate;
            } else {
              ++countProg;
              countProgs.push({ countProg: countProg, startDate: element.visitDate, endDate: element.visitDate });
              this.programData.push({ countProg: countProg, data: element });
            }
          }
        }
      );

      return countProgs.sort(this.compareNumeric);
    }
  },

  methods: {
    /**
     * Своя сортировка для программ
     */
    compareNumeric(a, b) {
      if (a.countProg < b.countProg) return 1;
      if (a.countProg > b.countProg) return -1;
    },

    /**
     * Обновление данных по программам
     */
    refresh() {
      this.$store.dispatch('programs/getProgramsData');
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param item
     */
    editOpen(item) {
      // Если редактирование
      if (item !== null && typeof item !== "undefined") {
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.programsData.indexOf(item);
        this.readonlyFields = true;
        // Если добавление
      } else {
        this.modalData = {
          id: -100,
          programId: null,
          programName: "",
          shopId: null,
          shopName: "",
          status: null,
          shopEmployeeId: null,
          employeeName: ""
        };

        this.oldModalData = {};
        this.editedIndex = -1;
        this.readonlyFields = false;
      }

      this.popupEdit.isOpen = true;
    },

    /**
     * Отмена редактирования
     */
    editCancel() {
      if (this.editedIndex != -1) {
        Object.assign(this.programsData[this.editedIndex], this.oldModalData);
      }
      this.popupEdit.isOpen = false;
    },

    /**
     * Сохранение отредактированного элемента
     */
    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('programs/saveProgramsData', { index: this.editedIndex, data: this.modalData })
          .then(() => {
            this.popupEdit.isOpen = false;
            this.$store.dispatch('log/getLogData');
          });
      }
    },

    /**
     * Открытие модального окна с подтверждением удаления
     * @param data
     */
    removeItemConfirm(data) {
      this.popupRemove.isOpen = true;
      this.modalData = data;
      this.programData = [];

      let pollsProgram = {
        programId: data.programId,
        shopEmployeeId: data.shopEmployeeId
      };

      this.$store.dispatch('pollsRunProgram/getPostPollsRunProgramData', { data: pollsProgram });
    },

    /**
     * Удаление программы и выбранные анкеты
     * @param item
     */
    actionRemove(item) {
      let removePolls = {};
      let strPolls = '';

      this.complexPollsProg.selected.forEach(element => {
        strPolls += element.data.docUid + '##';
      });

      removePolls.polls = strPolls;
      this.$store.dispatch('pollsRunProgram/removePollsData', { item: removePolls });
      this.$store.dispatch('programs/removeProgramsData', { item: item });
      this.popupRemove.isOpen = false;
    },

    /**
     * Удаление выбранных анкет
     * @param item
     */
    actionRemovePolls(item) {
      let removePolls = {};
      let strPolls = '';

      this.complexPollsProg.selected.forEach(element => {
        strPolls += element.data.docUid + '##';
      });

      removePolls.polls = strPolls;

      this.$store.dispatch('pollsRunProgram/removePollsData', { item: removePolls });
      this.popupRemove.isOpen = false;
    },

    /**
     * Обработка события изменения стоматолога
     * @param event
     */
    changeEmployee(event) {
      if (event !== null && typeof event === "object") {
        this.checkProgram =
          this.programsData.filter(
            program =>
              program.shopId === this.modalData.shopId &&
              program.shopEmployeeId === event.value &&
              program.programId === this.modalData.programId
          ).length === 0;

        console.log("проверка повтора " + this.checkProgram);

        if (this.checkProgram) {
          this.modalData.shopEmployeeId = event.value;
          this.modalData.employeeName = event.text;
          this.changeEmployeeTrigger = true;
        }
      }
    },

    /**
     * Обработка события изменения клиники
     * @param event
     */
    changeClinic(event) {
      if (event !== null && typeof event === "object") {
        this.modalData.shopId = event.value;
        this.modalData.shopName = event.text;
      }
    },

    /**
    * Смена программы
    */
    changeProgram(event) {
      if (event !== null && typeof event === "object") {
        this.modalData.programId = event.value;
        this.modalData.programName = event.text;
      }
    },

    /**
     * смена статуса по программе
     */
    changeStatus(event) {
      if (event !== null && typeof event === "object") {
        this.modalData.status = event.value;
        this.modalData.statusName = event.text;
      }
    },

    toggleAll() {
      this.selected = this.selected.length > 0 ? [] : this.desserts.slice();
    }
  }
};
</script>

<style>
.v-chip__content {
  cursor: pointer !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/ui/Programs.vue